import React from 'react';
import product_13 from '../assets/product_13.png'
import product_14 from '../assets/product_14.png'
import product_15 from '../assets/product_15.png'
import product_16 from '../assets/product_16.png'
import product_17 from '../assets/product_17.png'
import product_18 from '../assets/product_18.png'
import product_19 from '../assets/product_19.png'
import product_20 from '../assets/product_20.png'
import product_21 from '../assets/product_21.png'
import product_22 from '../assets/product_22.png'
import product_23 from '../assets/product_23.png'
import product_24 from '../assets/product_24.png'

import product_25 from '../assets/product_25.png'
import product_26 from '../assets/product_26.png'
import product_27 from '../assets/product_27.png'
import product_28 from '../assets/product_28.png'
import product_29 from '../assets/product_29.png'
import product_30 from '../assets/product_30.png'

const popularbidsData = [
  { id:1, amount: 100, time: '10:00 AM', imageUrl:product_13 },
  { id:2,amount: 150, time: '10:05 AM', imageUrl: product_14 },
  { id:3,amount: 200, time: '10:10 AM', imageUrl: product_15 },
  { id:4,amount: 180, time: '10:00 AM', imageUrl:product_16 },
  { id:5,amount: 120, time: '10:05 AM', imageUrl: product_17},
  { id:6,amount: 310, time: '10:10 AM', imageUrl: product_18 },
  { id:7,amount: 280, time: '10:10 AM', imageUrl: product_19 },
  { id:8,amount: 170, time: '10:00 AM', imageUrl:product_20},
  { id:9,amount: 125, time: '10:05 AM', imageUrl: product_21 },
  { id:10,amount: 315, time: '10:10 AM', imageUrl: product_22 },
  // Add more bid objects with image URLs
];
export default popularbidsData;